"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTextField = _interopRequireDefault(require("../cwtextfield/CwTextField"));

var _NumberUtils = require("../../utils/NumberUtils");

var _Enums = require("../../utils/Enums");

var CwNumberField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwNumberField, _React$Component);

  function CwNumberField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwNumberField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwNumberField).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (value) {
      //Keep acceptable states and bypass all other checks
      if ((0, _NumberUtils.checkAcceptableChangeState)(value, _this.props.negative, _this.props.decimal)) {
        _this.setState({
          value: value
        });

        _this.validButNotANumber = true;

        _this.props.onChange(null);

        return;
      }

      _this.validButNotANumber = false; //only allow one negative symbol

      if ((0, _NumberUtils.checkForOneNegativeAtProperLocation)(value, _this.props.negative, _this.props.negativeAtStart)) {
        return;
      }

      if (!(0, _NumberUtils.checkDecimalAgainstMaxLength)(value, _this.props.decimal, (0, _NumberUtils.generateMaxLength)(_this.state.value, _this.props.maxLength, _this.props.decimal, _this.props.maxDecimalUnits))) {
        _this.props.onChange(_this.formatToFloat(_this.props.value.toString()));

        return;
      }

      if (_this.props.maxDecimalUnits) {
        if ((0, _NumberUtils.checkforOneDecimalAndMaxDecimalUnits)(value, _this.props.decimal, _this.props.maxDecimalUnits)) {
          return;
        }
      } //only allow one decimal


      if ((0, _NumberUtils.checkForOneDecimal)(value, _this.props.decimal)) {
        return;
      }

      if (!(0, _NumberUtils.checkForLeftSideLength)(value, _this.props.maxLength, _this.props.decimal)) {
        return;
      } //Guard against NaN and pass up null if we cannot format things to a float.


      if (isNaN(_this.formatToFloat(value))) {
        _this.setState({
          value: ''
        });

        _this.props.onChange(null);

        return;
      }

      _this.setState({
        value: value
      });

      _this.props.onChange(_this.formatToFloat(value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "restrictLastDigit", function (value) {
      var newVal = value.substring(0, value.length - 1);

      _this.setState({
        value: newVal
      });

      if (isNaN(_this.formatToFloat(newVal))) {
        _this.validButNotANumber = true;

        _this.props.onChange(null);

        return;
      }

      _this.props.onChange(_this.formatToFloat(newVal));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFocus", function () {
      _this._focused = true;

      _this.setState(function (prevState) {
        return {
          prevValue: prevState.value
        };
      });

      if (_this.props.formatOnFocus) {
        var newVal = _this.props.formatOnFocus(_this.state.value);

        _this.setState({
          value: newVal
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      _this._typing = false;
      _this._focused = false;

      if (!_this.state.value) {
        _this.setState({
          value: ''
        });
        /* istanbul ignore next */


        if (_this.props.onBlur) {
          _this.props.onBlur();
        }

        return;
      }

      if (!_this.validButNotANumber) {
        _this.setState({
          value: _this.props.formatNumber(_this.formatToFloat(_this.state.value))
        });
      } else {
        _this.setState({
          value: ''
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function () {
      _this._typing = true;

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formatToFloat", function (value) {
      if (!value || typeof value !== "string") {
        return 0;
      }

      return (0, _NumberUtils.formatToAFloat)(value, _this.props.thousands, _this.props.decimal, _this.props.negative);
    });
    _this.state = {
      value: _this.props.value || _this.props.value === 0 ? _this.props.formatNumber(_this.props.value) : '',
      regex: _this.props.regex ? _this.props.regex : (0, _NumberUtils.regexCreator)(_this.props.negative, _this.props.decimal, _this.props.thousands),
      prevValue: _this.props.value ? _this.props.formatNumber(_this.props.value) : ''
    };
    _this._typing = false;
    _this._focused = false;
    _this.validButNotANumber = false;
    return _this;
  }

  (0, _createClass2.default)(CwNumberField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _NumberUtils.checkNextPropsWhileNotTyping)(nextProps.value, this._typing)) {
        this.setState({
          value: this.props.formatNumber(nextProps.value)
        });
      } else if ((nextProps.value || nextProps.value === '' || nextProps.value === 0) && (!this.state.value || this.state.value === '')) {
        this.setState({
          value: nextProps.value.toString(),
          prevValue: nextProps.value.toString()
        });
      } else if (!nextProps.value && nextProps.value !== 0 && !this.validButNotANumber) {
        this.setState({
          value: ''
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.selectAllOnFocus && this._focused && !this._typing) {
        this.textField.inputField.select();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.textField.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_CwTextField.default, {
        ref: function ref(item) {
          return _this2.textField = item;
        },
        cwId: this.props.cwId,
        value: this.state.value,
        onChange: this.handleChange,
        regex: this.state.regex,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        maxLength: (0, _NumberUtils.generateMaxLength)(this.state.value, this.props.maxLength, this.props.decimal, this.props.maxDecimalUnits),
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        onKeyPress: this.props.onKeyPress,
        tabIndex: this.props.tabIndex,
        invalid: this.props.invalid,
        disabled: this.props.disabled,
        id: this.props.id,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.props.onKeyUp,
        autoFocus: this.props.autoFocus,
        textAlignment: this.props.textAlignment ? this.props.textAlignment : this.props.inAGrid ? _Enums.AlignmentEnum.RIGHT : undefined,
        style: this.props.style
      });
    }
  }]);
  return CwNumberField;
}(_react.default.Component);

CwNumberField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Text in textfield
   */
  value: _propTypes.default.number,

  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes.default.string,

  /**
   * Used to set textfield to a read only mode
   */
  readOnly: _propTypes.default.bool,

  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired when any key is pressed
   */
  onKeyPress: _propTypes.default.func,

  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes.default.number,

  /**
   * Used to control if text is valid
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable textfield
   */
  disabled: _propTypes.default.bool,

  /**
   * Used as an identifier for the component
   */
  id: _propTypes.default.string,

  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: _propTypes.default.string,

  /**
   * Callback function that is fired when textfield is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when textfield is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function that is fired on key down
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Callback function that is fired on key up
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Change the input field type
   */
  type: _propTypes.default.string,

  /**
   * Used to control if numberfield is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * The maximium number of characters allowed in the field. Can never exceed 16
   */
  maxLength: _propTypes.default.number,

  /**
   * The negative symbol of the native locale
   */
  negative: _propTypes.default.string.isRequired,

  /**
   * The decimal symbol of the native locale
   */
  decimal: _propTypes.default.string.isRequired,

  /**
   * The thousands separator of the native locale
   */
  thousands: _propTypes.default.string.isRequired,

  /**
   * A function used to format the internal number value to a localized display string.
   */
  formatNumber: _propTypes.default.func.isRequired,

  /**
   * A bool to determine whether the negative symbol goes at the start or end of a string"
   */
  negativeAtStart: _propTypes.default.bool,

  /**
   * Format the internal value if need be. 
   */
  formatOnFocus: _propTypes.default.func,

  /**
   * The maximum number of places after the decimal
   * which the number field accepts.
   */
  maxDecimalUnits: _propTypes.default.number,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * Used to control if all text is highlighted on focus
   */
  selectAllOnFocus: _propTypes.default.bool
};
CwNumberField.defaultProps = {
  negative: '-',
  decimal: '.',
  thousands: ',',
  maxLength: 16,
  negativeAtStart: true
};
var _default = CwNumberField;
exports.default = _default;